<template>
  <v-form
    ref="lldTest"
    v-model="isValidationOk"
    lazy-validation>
    <v-container
      v-if="isNewLld"
      fill-height
      fluid
      grid-list-xl>
      <v-layout
        wrap>
        <v-flex
          xs12>
          <span>
            {{ $t('Save the new LLD before configure Leak Test') }}
          </span>
          <hr>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container
      v-else
      fill-height
      fluid
      grid-list-xl>
      <v-layout
        wrap>
        <MaglinkComponentDialogYesNo
          :key="dialogYN.key"
          :component-key="dialogYN.componentKey"
          :dialog="dialogYN.show"
          :title="dialogYN.title"
          :label-text="dialogYN.labelText"
          :custom-par1="dialogYN.action"
          :custom-par2="dialogYN.result"
          @dialogResultYesNo="onDialogResult"/>
        <v-flex
          xs12>
          <span>
            {{ $t('Automatic LLD leak test') }}
          </span>
          <hr>
        </v-flex>
        <v-flex
          xs6
          md3
          lg3>
          <v-switch
            v-model="lld.autoLeakTestEnabled"
            :label="`${ $t('Enabled ') }`"
            class="dover-input text-xs-center"
            @change="onAutoTestChange"/>
        </v-flex>
        <v-flex
          v-if="lld.autoLeakTestEnabled"
          xs12
          md12
          lg12>
          <div class="grey--text font-weight-light"> {{ autoTestLabels[0] }} </div>
          <v-btn-toggle
            v-model="autoLeakTestRepetition3"
            mandatory>
            <v-btn
              :value="1"
              text
              small
              color="dover-blue">
              {{ $t('continuous') }}
            </v-btn>
          </v-btn-toggle>
        </v-flex>
        <v-flex
          v-if="lld.autoLeakTestEnabled"
          xs12
          md6
          lg5>
          <div class="grey--text font-weight-light"> {{ autoTestLabels[1] }} </div>
          <v-btn-toggle
            v-model="autoLeakTestRepetition02"
            mandatory
            @change="onAutoTestChange">
            <v-btn
              v-for="(item) in autoTestModes02"
              :key="item.index"
              :value="item.value"
              text
              small
              color="dover-blue">
              {{ item.desc }}
            </v-btn>
          </v-btn-toggle>
        </v-flex>
        <v-flex
          v-if="lld.autoLeakTestEnabled"
          xs6
          md3
          lg3>
          <v-text-field
            v-model.number="autoLeakTestWarning02"
            :counter="2"
            :rules="rules.monthLimit"
            :label="`${ $t('Monthly warning (days)') }`"
            class="dover-input"
            @change="onAutoTestChange"/>
        </v-flex>
        <v-flex
          v-if="lld.autoLeakTestEnabled"
          xs6
          md3
          lg4>
          <span/>
        </v-flex>
        <v-flex
          v-if="lld.autoLeakTestEnabled"
          xs12
          md6
          lg5>
          <div class="grey--text font-weight-light"> {{ autoTestLabels[2] }} </div>
          <v-btn-toggle
            v-model="autoLeakTestRepetition01"
            mandatory
            @change="onAutoTestChange">
            <v-btn
              v-for="(item) in autoTestModes01"
              :key="item.index"
              :value="item.value"
              text
              small
              color="dover-blue">
              {{ item.desc }}
            </v-btn>
          </v-btn-toggle>
        </v-flex>
        <v-flex
          v-if="lld.autoLeakTestEnabled"
          xs6
          md3
          lg3>
          <v-text-field
            v-model.number="autoLeakTestWarning01"
            :counter="3"
            :rules="rules.yearLimit"
            :label="`${ $t('Yearly warning (days)') }`"
            class="dover-input"
            @change="onAutoTestChange"/>
        </v-flex>
        <v-flex
          xs12>
          <span>
            {{ $t('Scheduled leak test') }}
          </span>
          <hr>
        </v-flex>
        <v-flex
          xs6
          lg3
          md3>
          <v-select
            v-model="scheduledTest.leakageType"
            :items="testRates"
            :label="`${ $t('Leak Test Rate') }`"
            item-text="desc"
            item-value="index"
            class="dover-input"
            outline
            dense
            @change="onApplyRequestChanged" />
        </v-flex>
        <v-flex
          xs6
          md9
          lg9>
          <v-btn-toggle
            v-model="executionMode"
            mandatory
            @change="onExecutionModeChange">
            <v-btn
              :key="0"
              :value="0"
              text
              small
              color="dover-blue">
              {{ $t('Now') }}
            </v-btn>
            <v-btn
              :key="1"
              :value="1"
              text
              small
              color="dover-blue">
              {{ $t('Schedule') }}
            </v-btn>
          </v-btn-toggle>
        </v-flex>
        <v-flex
          v-if="executionMode !== 0"
          xs6
          md4
          lg4>
          <MaglinkComponentDateTimePicker
            :component-key="1"
            :rules-is-date="rules.isDate"
            :rules="rules.required.concat(rules.time)"
            :initial-date="scheduledDate"
            :date-format="dateFormat"
            :time-format="timeFormat"
            :date-label="`${ $t('Date') }`"
            :min-date="dateFromToday(0)"
            :max-date="dateFromToday(365)"
            :clear-date="false"
            :loading="executionMode === 0"
            @getDate="onGetDate"/>
        </v-flex>
        <v-flex
          xs6
          md8
          lg8/>
        <v-flex
          xs3
          md2
          lg2
          text-xs-center>
          <v-btn
            :disabled="!applyChanges"
            small
            class="mx-0 font-weight-light"
            color="dover-blue"
            @click="onApply()">
            {{ $t('Apply') }}
          </v-btn>
        </v-flex>
        <v-flex
          xs3
          md2
          lg2
          text-xs-center>
          <v-btn
            small
            class="mx-0 font-weight-light"
            color="dover-blue"
            @click="onDelete()">
            {{ $t('Delete') }}
          </v-btn>
        </v-flex>
        <v-flex
          xs12>
          <hr>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>

import { i18n } from '@/i18n'
import Vue from 'vue'

export default {
  props: {
    isNewLld: {
      type: Boolean,
      require: true,
      default: () => false
    },
    lld: {
      type: Object,
      required: true,
      default: () => {}
    },
    systemSettings: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    isValidationOk: false,
    applyChanges: false,
    dialogYN: {
      key: 0,
      show: false,
      componentKey: '',
      title: '',
      labelText: '',
      action: '',
      result: ''
    },
    dateFormat: 'dd/mm/hh',
    executionMode: 0,
    rules: {
      isDate: [ v => true ],
      required: [ v => Vue.prototype.Maglink.RulesRequired(v) ],
      time: [ v => Vue.prototype.Maglink.MinDate(v, new Date()) ],
      weekLimit: [ v => Vue.prototype.Maglink.RulesRange(v, 0, 7) ],
      monthLimit: [ v => Vue.prototype.Maglink.RulesRange(v, 0, 31) ],
      yearLimit: [ v => Vue.prototype.Maglink.RulesRange(v, 0, 365) ]
    },
    scheduledTest: {
      id: 0,
      lldNumber: 0,
      time: 0,
      leakageType: 0
    },
    timeFormat: 'hh:mm',
    testRates: [],
    autoTestLabels: [],
    autoTestModes02: [],
    autoTestModes01: [],
    autoLeakTestRepetition3: 1,
    autoLeakTestRepetition02: 0,
    autoLeakTestRepetition01: 0
  }),
  computed: {
    autoLeakTestWarning02: {
      get: function () {
        return Math.floor(this.lld.autoLeakTestWarning02 / (24 * 60))
      },
      set: function (value) {
        this.lld.autoLeakTestWarning02 = Math.floor(value) * (24 * 60)
      }
    },
    autoLeakTestWarning01: {
      get: function () {
        return Math.floor(this.lld.autoLeakTestWarning01 / (24 * 60))
      },
      set: function (value) {
        this.lld.autoLeakTestWarning01 = Math.floor(value) * (24 * 60)
      }
    },
    scheduledDate: {
      get: function () {
        if (this.scheduledTest.time > 0) {
          return new Date(this.scheduledTest.time * 1000)
        }
        return false
      },
      set: function (time) {
        this.scheduledTest.time = time
        this.executionMode = (time > 0 ? 1 : 0)
      }
    }
  },
  watch: {
    lld: {
      handler: function (newLld, oldLld) {
        if (newLld.lldNumber > 0) {
          this.Maglink.GetScheduledLeakTests()
            .then(response => {
              var st = response.data.filter(test => test.lldNumber === newLld.lldNumber)[0]
              if (st !== undefined) {
                this.scheduledTest.id = st.id
                this.scheduledTest.lldNumber = st.lldNumber
                this.scheduledDate = st.time
                this.scheduledTest.leakageType = st.leakageType
              }
            })
            .catch(error => (this.snack('error', error.message)))
          this.initializeAutoLeakRepetition()
        }
      },
      immediate: true
    }
  },
  mounted () {
    this.dateFormat = this.systemSettings.dateFormat
    this.autoTestLabels = [
      this.leakLabelFromGph(3.0),
      this.leakLabelFromGph(0.2),
      this.leakLabelFromGph(0.1)
    ]
    this.testRates = [
      { index: 0, value: 0.0, desc: this.$t('None') },
      { index: 3, value: 3.0, desc: this.leakLabelFromGph(3.0) },
      { index: 2, value: 0.2, desc: this.leakLabelFromGph(0.2) },
      { index: 1, value: 0.1, desc: this.leakLabelFromGph(0.1) }
    ]
    this.autoTestModes02 = [
      { index: 7, value: 7, desc: this.$t('Never') },
      { index: 1, value: 1, desc: this.$t('Daily') },
      { index: 2, value: 2, desc: this.$t('Weekly') },
      { index: 3, value: 3, desc: this.$t('Monthly') }
    ]
    this.autoTestModes01 = [
      { index: 7, value: 7, desc: this.$t('Never') },
      { index: 3, value: 3, desc: this.$t('Monthly') },
      { index: 4, value: 4, desc: this.$t('Yearly') }
    ]
    this.initializeAutoLeakRepetition()
  },
  methods: {
    leakLabel (leakValue) {
      var label = '' + this.Maglink.RoundFormat(this.Maglink.LeakageToDisplay(leakValue, this.systemSettings.volumeUnit), this.systemSettings.volumeUnit === 0 ? 2 : 1)
      label += ' ' + this.Maglink.LeakShortUdm(this.systemSettings.volumeUnit || 0)
      return label
    },
    leakLabelFromGph (leakValue) {
      return this.leakLabel(leakValue * 3.78541)
    },
    initializeAutoLeakRepetition () {
      // 02gph->monthly, 01gph->yearly   (1-daily,2-weekly,3-monthly,4-yearly)
      this.autoLeakTestRepetition02 = (this.lld.autoLeakTestRepetition & 0x07)
      this.autoLeakTestRepetition01 = ((this.lld.autoLeakTestRepetition >> 3) & 0x07)
      if (this.autoLeakTestRepetition02 === 0) {
        this.autoLeakTestRepetition02 = 3
      }
      if (this.autoLeakTestRepetition01 === 0) {
        this.autoLeakTestRepetition01 = 4
      }
    },
    setAutoLeakRepetition () {
      this.lld.autoLeakTestRepetition = (this.autoLeakTestRepetition01 << 3) + this.autoLeakTestRepetition02
      if (!this.lld.autoLeakTestEnabled) {
        this.autoLeakTestRepetition02 = 3
        this.autoLeakTestRepetition01 = 4
        this.lld.autoLeakTestRepetition = 0
        this.lld.autoLeakTestWarning02 = 0
        this.lld.autoLeakTestWarning01 = 0
      }
    },
    checkDate () {
      if (this.scheduledTest.time > 0) {
        // Check that the date is valid
        var dt = new Date((this.scheduledTest.time) * 1000)
        if (dt < new Date()) {
          this.rules.isDate = [this.$t('Wrong date value')]
          return false
        }
      }

      this.rules.isDate = [ v => true ]
      return true
    },
    dateFromToday (days) {
      var currentDate = new Date()
      currentDate.setDate(currentDate.getDate() + days)
      return currentDate
    },
    onApply () {
      let text = this.$t('Do you want to APPLY the leak test configuration?')

      this.dialogYN.title = this.$t('Manual Leak Test').toUpperCase()
      this.dialogYN.labelText = text
      this.dialogYN.componentKey = 'apply'
      this.dialogYN.action = 'apply'
      this.dialogYN.result = this.scheduledTest.id
      this.dialogYN.show = true
    },
    onApplyRequestChanged () {
      if (this.scheduledTest.lldNumber === 0) {
        this.scheduledTest.lldNumber = this.lld.lldNumber
      }

      var isApplicable = this.scheduledTest.lldNumber !== 0 && this.scheduledTest.leakageType > 0
      if (this.executionMode === 1) {
        isApplicable = isApplicable && this.scheduledTest.time > 0
      }

      this.applyChanges = isApplicable
    },
    onDelete () {
      let text = this.$t('Do you want to DELETE this leak test configuration?')

      this.dialogYN.title = this.$t('Manual Leak Test').toUpperCase()
      this.dialogYN.labelText = text
      this.dialogYN.componentKey = 'delete'
      this.dialogYN.action = 'delete'
      this.dialogYN.result = this.scheduledTest.id || 0
      this.dialogYN.show = true
    },
    onDialogResult (componentKey, result, action, par2) {
      this.dialogYN.show = false

      // NO button pressed
      if (!result) return

      if (componentKey === 'apply') {
        this.Maglink.ApplyScheduledLeakTest(this.scheduledTest)
          .then(response => {
            this.applyChanges = false
            this.scheduledTest.id = 0
            this.scheduledTest.leakageType = 0
            if (result.data !== undefined) {
              this.scheduledTest = result.data
            }
            let text = this.$t('Leak Test scheduled for LLD {0}', [ this.lld.lldDescription ])
            this.snack('success', text)
          })
          .catch(error => (this.snack('error', error.message)))
      } else if (componentKey === 'delete') {
        this.Maglink.DeleteScheduledTest(this.scheduledTest.lldNumber)
          .then(response => {
            this.resetData()
            let text = this.$t('Leak Test deleted for LLD {0}', [ this.lld.lldDescription ])
            this.snack('success', text)
          })
          .catch(error => (this.snack('error', error.message)))
      }
    },
    onExecutionModeChange () {
      if (this.executionMode === 0) {
        this.scheduledDate = 0
      }

      this.onApplyRequestChanged()
    },
    onGetDate (componentKey, date) {
      this.scheduledTest.time = !date ? 0 : date.getTime() / 1000

      if (this.checkDate()) {
        this.onApplyRequestChanged()
      }
    },
    resetData () {
      this.scheduledTest.id = 0
      this.scheduledTest.lldNumber = 0
      this.scheduledDate = 0
      this.scheduledTest.leakageType = 0
      this.executionMode = 0
    },
    onAutoTestChange () {
      if (this.$refs.lldTest.validate()) {
        this.isValidationOk = true
        this.setAutoLeakRepetition()
        this.$emit('dataChanged', true)
      } else {
        this.isValidationOk = false
        this.$emit('dataChanged', false)
      }
    },
    snack (color, message) {
      message = i18n.t('Line leak config') + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
